import { EventBus } from '@/services/EventBus'
import CircleProgress from '@/components/circleProgress/CircleProgress.vue'
import Tooltip from '@/components/tooltip/Tooltip.vue'
export default {
    name: 'download-list-item',
    props: {
        video:{
            type: Object,
            default: {
                intervalDateVideo: null,
                percent: null,
                source_id: null,
                session: null,
                link: null,
                statusLoad: null,
                tooltipText: null,
            }
        },
        index: {
            type: Number,
            required: true
        }
    },
    methods: {
        deleteVideo(){
            EventBus.$emit('stop-export-file', this.video.session);
            this.$store.commit('deleteUplodedVideo', this.video.session);
        }
    },
    components:{
        CircleProgress,
        Tooltip
    }
};


// WEBPACK FOOTER //
// ./src/components/downloadList/downloadListItem/downloadListItem.js